import Vue from 'vue'
import Vuex from 'vuex'
import db from '@/firebase/firestore.js'
import Dexie from 'dexie'

Vue.use(Vuex)

// export default new Vuex.Store({
//   state: {
//   },
//   mutations: {
//   },
//   actions: {
//   },
//   modules: {
//   }
// })

const systemState = {
    namespaces: true,
    state: {
        systemVersion: "3.2.1",
        // Homeの表示画面モード
        homeMode: "",
        // 画面下部のホームボタン押下によるホーム画面への遷移を要求する時に、True に設定する。
        requestBackToHome: false,
        // 画面下部のQR読取ボタンを有効にする時に、True に設定する。
        enabledQRScan: false,
        // 画面下部のQR読取ボタン押下によるQR読み取りを要求する時に、True に設定する。
        requestQRScan: false,
        // ログイン状態(0:初期,1:ログイン中,2:ログアウト)
        loginState: 0,
        // 共有モード(0:通常,1:フォローユーザーの作業参照,2:グループユーザーの作業参照)
        shareMode: 0,
        // 共有モード種類
        shareModeTypes: {
            myWork: 0,
            groupUserWork: 2
        },
        // 長時間処理中(True:処理中)
        processing: false,
        // 長時間処理のメッセージ
        processingMessage: "",
        showNotification: false,
        notification: {
            isView: false,
            message: "",
            color: "primary"
        },
        // キャッシュされたユーザー
        cachedUsers: [],
        localDB: null,
        // サイドメニューから選択された項目
        selectedMenuItem: ""
    },
    getters: {
        systemVersion: function (state) {
            return state.systemVersion
        },
        homeMode: function (state) {
            return state.homeMode
        },
        loginState: function (state) {
            return state.loginState
        },
        requestBackToHome: function (state) {
            return state.requestBackToHome
        },
        enabledQRScan: function (state) {
            return state.enabledQRScan
        },
        requestQRScan: function (state) {
            return state.requestQRScan
        },
        shareMode: function (state) {
            return state.shareMode
        },
        shareModeTypes: function (state) {
            return state.shareModeTypes
        },
        processing: function (state) {
            return state.processing
        },
        processingMessage: function (state) {
            return state.processingMessage
        },
        notification: function (state) {
            return state.notification
        },
        cachedUsers: function (state) {
            return state.cachedUsers
        },
        localDB: function (state) {
            if (state.localDB == null) {
                // Dexie.delete("harvest")
                state.localDB = new Dexie("harvest")
                state.localDB.version(1).stores({
                    operationLog: '++id, dateTime, componentID, method, data'
                })
                state.localDB.version(2).stores({
                    operationLog: '++id, dateTime, path, data'
                })
                state.localDB.version(3).stores({
                    operationLog: '++id',
                    users: '++id, lastLoggedInDate',
                })
                state.localDB.version(3).stores({
                    operationLog: '++id',
                    users: '++id, email, lastLoggedInDate',
                })
            }
            return state.localDB
        },
        selectedMenuItem: function (state) {
            return state.selectedMenuItem
        }
    },
    mutations: {
        homeMode: function (state, value) {
            state.homeMode = value
        },
        loginState: function (state, value) {
            state.loginState = value
        },
        requestBackToHome: function (state, enabled) {
            state.requestBackToHome = enabled
        },
        enabledQRScan: function (state, enabled) {
            state.enabledQRScan = enabled
        },
        requestQRScan: function (state, enabled) {
            state.requestQRScan = enabled
        },
        shareMode: function (state, value) {
            state.shareMode = value
        },
        processing: function (state, params) {
            try{
                if (params == null) {
                    params = {
                        start: false
                    }
                }
                if (params.start == undefined || params.start == null) {
                    params.start = false
                }
                state.processing = params.start
    
                if (state.processing == false) {
                    return
                }
    
                if (params.message == undefined) {
                    params.message = "処理中です。"
                }
                state.processingMessage = params.message
                state.processing = true

            } catch (error) {
                console.log(error)
            }
        },
        notification: function (state, params) {
            if (params.isError == undefined || params.isError == null) {
                params.isError = false
            }
            if (params.isError) {
                state.notification.color = "error"
            } else {
                state.notification.color = "primary"
            }
            state.notification.message = params.message
            state.notification.isView = true
        },
        cachedUsers: function (state, users) {
            state.cachedUsers = users
        },
        selectedMenuItem: function (state, value) {
            // console.log("selectedMenuItem", value)
            state.selectedMenuItem = value
        }
    }
}

const userData = {
    namespaces: true,
    state: {
        firebaseUser: null,
        userUID: null,
        userData: null,
        userLicense: null,
        // 共有モードで参照中のユーザー情報
        // {
        //     group: 所属グループ,
        //     user: {
        //         body:
        //         userInfo:
        //     }
        // }
        sharedUserInformation: null,
    },
    getters: {
        publicSettingTypes: function (state) {
            return [
                {text:"公開しない", value:0, content:"他のユーザーはあなたを見つける事は出来ません。"},
                {text:"名前だけ公開する", value:1, content:"他のユーザーはあなたを名前で検索する事が出来ます。"},
                {text:"名前と住所を公開する", value:3, content:"他のユーザーはあなたを名前と住所(郵便番号,県名,市名)で検索する事が出来ます。"},
            ]
        },
        /**
         * ログイン中のユーザーのユーザーデータ
         * @param {*} state 
         */
        loggedInUserData: function (state) {
            return state.userData
        },
        /**
         * ログイン中のユーザーのユーザーUID
         * @param {*} state 
         */
        loggedInUserUID: function (state) {
            return state.userUID
        },
        /**
         * ログイン中のユーザーに設定されているライセンスのライセンスデータ
         * @param {*} state 
         */
        loggedInUserLicense: function (state) {
            return state.userLicense
        },
        /**
         * グループユーザーのデータ参照中は、そのユーザーのUID
         * 参照していない時は、ログイン中のユーザーのユーザーUID
         * @param {*} state 
         */
        userUID: function (state) {
            switch (systemState.state.shareMode) {
                case systemState.state.shareModeTypes.myWork:
                    return state.userUID
                case systemState.state.shareModeTypes.groupUserWork:
                    return state.sharedUserInformation.user.body.userUID
            }
        },
        /**
         * firebaseのユーザー情報
         * @param {*} state 
         */
        firebaseUser: function (state) {
            return state.firebaseUser
        },
        // 現在の参照ユーザーのユーザー情報
        // 共有先ユーザーのデータ参照時は、そのユーザー
        // それ以外はログインユーザー
        userData: function (state) {
            switch (systemState.state.shareMode) {
                case systemState.state.shareModeTypes.myWork:
                    return state.userData
                case systemState.state.shareModeTypes.groupUserWork:
                    return state.sharedUserInformation
            }

            // if (state.sharedUserInformation != null) {
            //     console.log("store/index.js", "userData(read)", state.sharedUserInformation.userData)
            //     return state.sharedUserInformation.userData
            // }
            // console.log("store/index.js", "userData(read)", state.userData)
            // return state.userData
        },
        sharedUser: function (state) {
            return state.sharedUserInformation
        },
        groupMemberStates: function (state) {
            return [
                {value:0, text:"無効"},
                {value:1, text:"参加中"},
                {value:2, text:"参加拒否"},
                {value:3, text:"参加取りやめ"},
                {value:10, text:"参加依頼への返信待ち"},
            ]
        }
    },
    mutations: {
        firebaseUser: function (state, value) {
            // console.log("store/index.js", "firebaseUser(write)", value)
            state.firebaseUser = value
        },
        userUID: function (state, value) {
            // console.log("store/index.js", "userUID(write)", value)
            state.userUID = value
        },
        userData: function (state, value) {
            // console.log("store/index.js", "userData(write)", value)
            state.userData = value
        },
        sharedUser: function (state, user) {
            // console.log("store/index.js", "sharedUser(write)", user)
            state.sharedUserInformation = user
        },
        /**
         * ユーザーのライセンスを設定
         * @param {*} state 
         * @param {*} license 
         */
        userLicense: function (state, license) {
            state.userLicense = license
        },
        // params: {
        //     userUID:,
        //     completed:
        //     failed:
        // }
        refreshUserData: function (state, params) {
            // console.log("store/index.js", "refreshUserData", "start", params)
            state.userData = null

            db.collection("users").doc(params.userUID).get().then(function(doc){
                state.userData = doc.data()
                if (state.userData == undefined || state.userData.userUID == undefined) {
                    state.userData = null
                }
                if (params.completed != null) {                    
                    params.completed()
                }
            }).catch (function (error){
                if (params.failed != null) {
                    params.failed(error)
                }
            })
        },
        // params: {
        //     userUID,
        //     userData:,
        //     success:,
        //     failed:
        // }
        updateUserData: function (state, params) {
            // console.log("store/index.js", "updateUserData", "start", params)

            var fillZero = function ( number ) {
                return ("0" + number).slice(-2);
            }                      

            const d = new Date()

            var currentDateTime = d.getFullYear() + "-" + fillZero(d.getMonth()+1) + "-" + fillZero(d.getDate()) + " " +
                                  fillZero(d.getHours()) + ":" + fillZero(d.getMinutes()) + ":" + fillZero(d.getSeconds())

            if (params.userData.registeredDateTime == "") {
                params.userData.registeredDateTime = currentDateTime
            } else {
                params.userData.updatedDateTime = currentDateTime
            }
            
            db.collection("users").doc(params.userUID).set(params.userData).then(function(){
                if (params.success != null) params.success()
            }).catch(function(error){
                if (params.failed != null) params.failed(error)
            })

        },
        // // 同じユーザーIDのユーザーが登録されているかチェックして、結果をコールバックする
        // // params: {
        // //     userID:
        // //     success: コールバック先(結果(True:未登録,False:登録済))
        // //     failed:
        // // }
        // checkRegisteredSamekUserID: function (state, params) {
        //     db.collection("users").where("userID", "==", params.userID).get().then(function(snapShot){
        //         if (snapShot.size == 0) {
        //             params.success(true)
        //         } else {
        //             params.success(false)
        //         }
        //     }).catch (function (error){
        //         params.failed(error)
        //     })
        // }
    }
}

// ========================================================================================================================================================================================
/**
 * 地域情報
 */
const areaInformation = {
    namespaces: true,
    state: {
        /**
         * 登録されている全地域
         */
        areas: []
    },
    getters: {
        areas: function (state) {
            return state.areas
        }
    },
    mutations: {
        refreshArea: function (state) {
            state.areas = []
            db.collection("areas").orderBy("pref").orderBy("city").get().then(function(snapShot){
                snapShot.forEach(function(doc){
                    const area = doc.data()
                    state.areas.push(area)
                })
            })
        }
    }
}

// ========================================================================================================================================================================================
/**
 * 管理項目
 */
const managementItems = {
    namespaced: true,
    state: {
        // コールバック先
        callbacks: {
            userSetter: null,
            logger: null
        },
        // 送受信した通知
        notifications: {
            // スナップショットから読み取る最大レコード数(この数値分読み取れなかった時は、allReaded=true となる)
            maxReadNum: 10,
            // 送信通知リスト
            sendList: {
                list: [],
                allReaded: false
            },
            // 受信通知リスト
            receiveList: {
                list: [],
                allReaded: false
            }
        },
        // 所有する全グループ
        groups: [
            {
                // グループ本体
                body: null,
                // 所属する全ユーザー
                users: [
                    {
                        body: null,
                        userInfo: {
                            userName: null,
                            avaterURL: null
                        }
                    }
                ]
            }
        ],
        // 所属している全グループ
        belongGroups: [
            {
                // 所属グループ本体
                body: null,
                // グループ本体
                grooup: null,
                // グループの所有者情報
                ownerInfo: {
                    userName: null,
                    avaterURL: null
                },
                // 所属する全ユーザー
                users: [
                    {
                        body: null,
                        userInfo: {
                            userName: null,
                            avaterURL: null
                        }
                    }
                ]
            }
        ],
        // 共有中に参照しているユーザーが所属しているグループでの自分のユーザーデータ
        // ※このデータの権限を参照して、各処理の制限を行う
        // ※共有中によみ有効
        shareUserGroupMyUserData: null,
        // 場所毎のグループメンバーに設定出来る全権限
        placeGroupUserAuthorities: [
            {key: "browse", text: "参照"},
            {key: "work", text: "作業の参照"},
            {key: "work.record", text: "作業の参照と作業記録"},
            {key: "environment", text: "環境の参照"},
            {key: "environment.record", text: "環境の参照と記録"},
        ],
        // グループユーザーに設定出来る権限(※未使用)
        groupMemberAuthorities: [
            {key: "place", text: "圃場参照"},
            {key: "place.work", text: "圃場作業の参照"},
            {key: "place.work.record", text: "圃場作業の参照と作業記録"},
            {key: "place.environment", text: "圃場環境の参照"},
            {key: "place.environment.record", text: "圃場環境の参照と記録"},
        ],
        // システムに登録されている全病気データ
        sicks: null,
        sicksArray: [],
        // システムに登録されている全害虫データ
        vermins: null,
        verminsArray: [],
        // システムに登録されている全農薬データ
        // {body:基礎データ, items[]:農薬}
        agrichemicals: [],
        /** システムに登録されている全作業種類 */
        systemWorkTypes: [],
        // ログインユーザーの圃場データ
        loggedInUserPlaceData: {
            // 全場所グループ
            groups: [],
            // 全場所
            places: [],
            // 全作業種類
            workTypes: [],
            // 全栽培区分
            cultivationTypes: [],
            // 作付作物
            crops: [],
            getCount: 0
        },
        /**
         * 参照中のグループユーザーの圃場データ
         */
        groupUserPlaceData: {
            // ユーザーUID
            userUID: "",
            // 全場所グループ
            groups: [],
            // 全場所
            places: [],
            // 全作業種類
            workTypes: [],
            // 全栽培区分
            cultivationTypes: [],
            // 作付作物
            crops: [],
            getCount: 0
        },
    },
    getters: {
        /**
         * 送受信した通知
         * @param {*} state 
         */
        notifications: function (state) {
            return state.notifications
        },
        /**
         * 自分の全グループ
         * @param {*}} state 
         */
        groups: function (state) {
            return state.groups
        },
        /**
         * 所属している全グループ
         * @param {*} state 
         */
        belongGroups: function (state) {
            return state.belongGroups
        },
        /**
         * 場所毎のグループメンバーに設定出来る全権限
         * @param {*} state 
         */
        placeGroupUserAuthorities: function (state) {
            return state.placeGroupUserAuthorities
        },
        /**
         * グループユーザーに設定出来る権限(※未使用)
         * @param {*} state 
         */
        groupMemberAuthorities: function (state) {
            return state.groupMemberAuthorities
        },
        /**
         * 共有中に参照しているユーザーが所属しているグループでの自分のユーザーデータ
         * @param {*} state 
         */
        shareUserGroupMyUserData: function (state) {
            return state.shareUserGroupMyUserData
        },
        /**
         * システムに登録されている全病気データ
         * @param {*} state 
         */
        sicks: function (state) {
            return state.sicks
        },
        sicksArray: function (state) {
            return state.sicksArray
        },
        /**
         * システムに登録されている全害虫データ
         * @param {*} state 
         */
        vermins: function (state) {
            return state.vermins
        },
        verminsArray: function (state) {
            return state.verminsArray
        },
        /**
         * システムに登録されている全農薬基礎データ
         * @param {*} state 
         */
        agrichemicals: function (state) {
            return state.agrichemicals
        },
        /**
         * ログインしているユーザーの圃場データ
         * @param {*} state 
         */
        loggedInUserPlaceData: function (state) {
            return state.loggedInUserPlaceData
        },
        /**
         * 参照中のグループユーザーの圃場データ
         */
        groupUserPlaceData: function (state) {
            return state.groupUserPlaceData
        },
        /**
         * 参照中のグループユーザーの圃場データの権限設定
         * @param {*} state 
         */
        groupUserPlaceAuthority: function (state) {
            return state.groupUserPlaceAuthority
        }
    },
    mutations: {
        // =================================================================================================================
        /**
         * システムの作業種類の管理を開始
         * @param {*} state 
         */
        startManagementSystemWorkTypes: async function (state) {
            state.callbacks.logger("index/startManagementSystemWorkTypes", "start")

            try {
                state.systemWorkTypes = []

                await db.collection("system").doc("template")
                .collection("place_work_types").orderBy("orderNo", "asc").get().then(function(snapShot){
                    snapShot.forEach(function(doc){
                        const workType = doc.data()
                        state.systemWorkTypes.push(workType)
                    })
                }).catch (function(error) {
                    state.callbacks.logger("index/startManagementSystemWorkTypes", "exception(1)("+error+")")
                })
            } catch (error) {
                state.callbacks.logger("index/startManagementSystemWorkTypes", "exception(2)("+error+")")
            }
        },
        // =================================================================================================================
        /**
         * ログイン中のユーザーの圃場データの管理を開始
         * @param {*} state 
         */
        startManagementLoggedInUserPlaceData: function (state) {
            state.callbacks.logger("index/startManagementLoggedInUserPlaceData", "start")
            // console.log("startManagementLoggedInUserPlaceData")

            try {
                this.commit(
                    "managementItems/_setUserPlaceData", 
                    {
                        userUID: this.getters["loggedInUserUID"],
                        placeData: state.loggedInUserPlaceData,
                    }
                )
            } catch (error) {
                state.callbacks.logger("index/startManagementLoggedInUserPlaceData", "exception("+error+")")
            }
        },
        // =================================================================================================================
        /**
         * 指定されたグループメンバーユーザーの圃場データの管理を開始
         * @param {*} state 
         * @param {*} userUID 
         */
        startManagementGroupUserPlaceData: function (state, params) {
            state.callbacks.logger("index/startManagementGroupUserPlaceData", "start")
            // console.log("startManagementGroupUserPlaceData", userUID)

            try {
                state.groupUserPlaceData.userUID = params.userUID
                this.commit(
                    "managementItems/_setUserPlaceData", 
                    {
                        userUID: params.userUID,
                        placeData: state.groupUserPlaceData,
                    }
                )
            } catch (error) {
                state.callbacks.logger("index/startManagementGroupUserPlaceData", "exception("+error+")")
            }
        },
        // =================================================================================================================
        /**
         * 指定されたユーザーの圃場データを指定されたオブジェクトにセットします。
         * @param {*} state 
         * @param {*} params 
         */
        _setUserPlaceData: async function (state, params) {

            const self = this
            const userUID = params.userUID

            console.log("index.js", "_setUserPlaceData", params)
            
            // 全場所グループ
            params.placeData.groups = []
            // 全場所
            params.placeData.places = []
            // 全品目
            params.placeData.crops = []
            // 全栽培区分
            params.placeData.cultivationTypes = []

            const placeData = params.placeData

            // 登録済みの全場所取得
            var placesGetter = async function () {

                try {
                    await db.collection("users").doc(userUID).collection("places").where("isDeleted", "==", false).get().then(async function(refPlaces){
                        for (var i=0; i<refPlaces.docs.length; i++) {
                            params.placeData.getCount++
                            const docPlace = refPlaces.docs[i]
                            self.commit(
                                "managementItems/addUserPlace", 
                                {
                                    userUID: userUID,
                                    placeData: placeData, 
                                    place: docPlace.data()
                                }
                            )
                        }
                    }).catch (function(error) {
                        state.callbacks.logger("index/_setUserPlaceData/placesGetter", "exception(1)("+error+")")
                    })
                } catch (error) {
                    state.callbacks.logger("index/_setUserPlaceData/placesGetter", "exception(2)("+error+")")
                }
            }

            // 登録済みの全グループ取得
            // 取得後、全場所を取得処理へ
            try {
                db.collection("users").doc(userUID).collection("managements").doc("place_group").collection("groups").get().then(function(snapShot){
                    if (snapShot.size == 0) {
                        placesGetter()
                    } else {
                        snapShot.forEach(function(doc){
                            params.placeData.getCount++
                            placeData.groups.push(doc.data())
                            if (placeData.groups.length == snapShot.size) {
                                placesGetter()
                            }
                        })
                    }
                }).catch (function(error) {
                    state.callbacks.logger("index/_setUserPlaceData(圃場グループ取得)", "exception(1)("+error+")")
                })
            } catch (error) {
                state.callbacks.logger("index/_setUserPlaceData(圃場グループ取得)", "exception(2)("+error+")")
            }

            // console.log("place group completed")

            // 登録済みの全作物取得
            try {
                db.collection("users").doc(userUID).collection("crops").get().then(function(refCrops){
                    if (refCrops.size == 0) {
                    } else {
                        refCrops.forEach(function(docCrop){
                            params.placeData.getCount++
                            const crop = {
                                body: docCrop.data(),
                                varieties: []
                            }
                            placeData.crops.push(crop)
                            db.collection("users").doc(userUID).collection("crops").doc(""+crop.body.cropID).collection("varieties").get().then(function(refVarieties){
                                refVarieties.forEach(function(docVariety, varietyIndex){
                                    params.placeData.getCount++
                                    crop.varieties.push(docVariety.data())
                                })
                            }).catch (function(error) {
                                state.callbacks.logger("index/_setUserPlaceData(品目・品種取得)", "exception(1)("+error+")")
                            })
                        })
                    }
                }).catch (function(error) {
                    state.callbacks.logger("index/_setUserPlaceData(品目・品種取得)", "exception(2)("+error+")")
                })
            } catch (error) {
                state.callbacks.logger("index/_setUserPlaceData(品目・品種取得)", "exception(3)("+error+")")
            }

            // console.log("crops completed")

            // 登録済みの全栽培区分
            try {
                db.collection("users").doc(userUID).collection("managements").doc("cultivation_type").collection("cultivation_types").orderBy("type").get().then(function(snapShot){
                    if (snapShot.size == 0) {
                        db.collection("system").doc("template").collection("cultivation_types").get().then(function(snapShot){
                            snapShot.forEach(function(doc){
                                params.placeData.getCount++
                                const item = doc.data()
                                placeData.cultivationTypes.push(item)
                                db.collection("users").doc(userUID).collection("managements").doc("cultivation_type").collection("cultivation_types").doc(""+item.type).set(item).then(function(){
                                })
                            })
                        })
                    } else {
                        snapShot.forEach(function(doc){
                            params.placeData.getCount++
                            placeData.cultivationTypes.push(doc.data())
                        })
                    }
                })    
            } catch (error) {
                state.callbacks.logger("index/_setUserPlaceData(全栽培区分取得)", "exception("+error+")")
            }
        },
        /**
         * 指定された圃場データに指定されたユーザーの場所データを追加
         * @param {*} state 
         * @param {*} params 
         */
        addUserPlace: async function (state, params) {

            try {
                const userUID = params.userUID
                const placeData = params.placeData
    
                const place = {
                    body: params.place,                 // 場所データ
                    works: [],                          // 全作業
                    agrichemicalsHistory: null,         // 農薬使用履歴
                    workTypes: null,                    // システムプリセットの全作業種類
                    userWorkTypes: null,                // ユーザー作成の全作業種類
                    authorities: null                   // グループ別ユーザー別の権限設定
                }
    
                placeData.places.push(place)
    
                const refWorks = db.collection("users").doc(userUID).collection("places").doc(""+place.body.placeID).collection("works")
    
                // 作業監視
                refWorks.onSnapshot(function(snapShot){
                    snapShot.docChanges().forEach(function(change){

                        try {
                            params.placeData.getCount++
                            const changedWork = change.doc.data()
                            const changedWorkIndex = place.works.findIndex((v)=>v.workID == changedWork.workID)
                            // console.log("notifications changed", change.type, changedNotification)
                            switch (change.type) {
                                case "added":
                                    // 追加時
                                    console.log("index.js", "addUserPlace", "new place work!!", changedWork, snapShot.metadata.hasPendingWrites)
                                    place.works.push(changedWork)
                                    break;
                                case "modified":
                                    // 変更時
                                    if (!snapShot.metadata.hasPendingWrites) {
                                        console.log("index.js", "addUserPlace", "place work data changed!!", changedWork)
                                        place.works.splice(changedWorkIndex, 1)
                                        place.works.splice(changedWorkIndex, 0, changedWork)
                                    }
                                    break;
                                case "removed":
                                    // 削除時
                                    if (changedWorkIndex >= 0) {
                                        place.works.splice(changedWorkIndex, 1)
                                        console.log("index.js", "addUserPlace", "place work data deleted!!", changedWork, snapShot.metadata.hasPendingWrites)
                                    }
                                    break;
                            }    
                        } catch (error) {
                            state.callbacks.logger("index/addUserPlace(作業監視)", "exception("+error+")")
                        }
                    })
                },
                function (error) {
                    console.log("index.js", "addUserPlace", error)
                    state.callbacks.logger("index/addUserPlace(作業監視)", "exception("+error+")")
                })
    
                // <--------------- 監視しない時(ここを戻すだけではだめ。 works配列にセット、削除している箇所も変更必要)
                // await db.collection("users").doc(userUID)
                // .collection("places").doc(""+place.body.placeID)
                // .collection("works").get().then(function(refWorks){
                //     if (refWorks.size == 0) {
                //     } else {
                //         for (var j=0; j<refWorks.docs.length; j++) {
                //             const work = refWorks.docs[j].data()
                //             place.works.push(work)
                //         }
                //     }
                // })
                // --------------->

                try {
                    if (place.body.managementAgrichemical.enabled && place.agrichemicals == null) {

                        /** 農薬毎の使用履歴 */
                        await db.collection("users").doc(userUID)
                        .collection("places").doc(place.body.placeID+"")
                        .collection("agrichemical_histories").doc(place.body.managementAgrichemical.target+"").get().then(function(docHistories){
                            if (docHistories.exists) {
                                params.placeData.getCount++
                                const history = docHistories.data()
                                place.agrichemicalsHistory = history
                            } else {
                                place.agrichemicalsHistory = {
                                    version: "1.0.0",
                                    placeID: place.body.placeID,
                                    target: place.body.managementAgrichemical.target,
                                    agrichemicals: {}
                                }
                            }
                        }).catch (function(error) {
                            state.callbacks.logger("index/addUserPlace(農薬使用履歴取得)", "exception(1)("+error+")")
                        })
                    }    
                } catch (error) {
                    state.callbacks.logger("index/addUserPlace(農薬使用履歴取得)", "exception(2)("+error+")")
                }
    
                // 指定された作業種類に対して、場所毎のユーザーが作成した作業記録項目を取得してセットするファンクション
                const userRecordItemSetter = async function (workType) {

                    try {
                        await db.collection("users").doc(userUID)
                        .collection("places").doc(place.body.placeID+"")
                        .collection("place_work_types").doc(workType.workTypeID+"")
                        .collection("record_items").orderBy("orderNo", "asc").get().then(function(snapShot){
                            snapShot.forEach(function(doc){
                                params.placeData.getCount++
                                const item = doc.data()
                                workType.recordItems.push(item)
                            })
                        }).catch (function (error) {
                            state.callbacks.logger("index/addUserPlace/userRecordItemSetter", "exception(1)("+error+")")
                        })
                    } catch (error) {
                        state.callbacks.logger("index/addUserPlace/userRecordItemSetter", "exception(2)("+error+")")
                    }
                }
    
                // システムプリセットの全作業種類を場所にコピーして、コピーしたオブジェクトの作業記録項目の配列にユーザー作成の作業記録項目をセット
                try {
                    place.workTypes = []
                    state.systemWorkTypes.forEach(function(systemWorkType){
                        const workType = JSON.parse(JSON.stringify(systemWorkType))
                        place.workTypes.push(workType)
                        userRecordItemSetter(workType)
                    })
                } catch (error) {
                    state.callbacks.logger("index/addUserPlace(システムプリセット作業種類セット)", "exception("+error+")")
                }
    
                // ユーザーの全作業種類取得
                try {
                    place.userWorkTypes = []
                    await db.collection("users").doc(userUID)
                    .collection("places").doc(place.body.placeID+"")
                    .collection("place_work_types").where("workTypeID", ">=", 101).get().then(function(snapShot){
                        snapShot.forEach(function(doc){
                            params.placeData.getCount++
                            const workType = doc.data()
                            place.userWorkTypes.push(workType)
                            userRecordItemSetter(workType)
                        })
                    }).catch (function(error) {
                        state.callbacks.logger("index/addUserPlace(ユーザー作業種類取得)", "exception(1)("+error+")")
                    })
                } catch (error) {
                    state.callbacks.logger("index/addUserPlace(ユーザー作業種類取得)", "exception(2)("+error+")")
                }

                // 場所のグループ別ユーザー別の権限設定を取得
                try {
                    place.authorities = []
                    await db.collection("users").doc(userUID)
                    .collection("places").doc(place.body.placeID+"")
                    .collection("authorities").get().then(function(snapShot){
                        snapShot.forEach(function(doc){
                            params.placeData.getCount++
                            const authorities = doc.data()
                            place.authorities.push(authorities)
                        })
                    }).catch (function(error) {
                        console.log(error)
                        state.callbacks.logger("index/addUserPlace(グループ別権限取得)", "exception(1)("+error+")")
                    })
                } catch (error) {
                    console.log(error)
                    state.callbacks.logger("index/addUserPlace(グループ別権限取得)", "exception(2)("+error+")")
                }
            } catch (error) {
                console.log("addUserPlace", "exception", error)
                state.callbacks.logger("index/addUserPlace", "exception("+error+")")
            }

        },
        // =================================================================================================================
        /**
         * 共有中に参照しているユーザーが所属しているグループでの自分のユーザーデータを
         * 指定されたパラメーターのグループ所有者+グループNo.を元にDBから取得してセットする。
         * @param {*} state 
         * @param {*} params {ownerUserUID, groupNo}
         */
        setShareUserGroupMyUserData: async function (state, params) {
            const userUID = this.getters["loggedInUserUID"]
            const docGroupUser = db.collection("users").doc(params.ownerUserUID).collection("groups").doc(params.groupNo+"").collection("users").doc(userUID)
            await docGroupUser.get().then(function(doc){
                state.shareUserGroupMyUserData = doc.data()
                // console.log("setShareUserGroupMyUserData", state.shareUserGroupMyUserData)
            }).catch (function(error) {
                state.callbacks.logger("index/setShareUserGroupMyUserData", "exception("+error+")")
            })
            // docGroupUser.onSnapshot(function(doc){
            //     console.log("setShareUserGroupMyUserData changed", doc, doc.data())
            //     if (doc.exists) {
            //         // 変更された時
            //         state.shareUserGroupMyUserData = doc.data()
            //     } else {
            //         // 削除された時
            //         state.shareUserGroupMyUserData = null
            //     }
            // })
        },
        // =================================================================================================================
        /**
         * 汎用ツールへのコールバック先を設定
         * @param {*} state 
         * @param {*} callbacks 
         */
        setCallbacks: function (state, callbacks) {
            state.callbacks = callbacks
        },        
        // =================================================================================================================
        /**
         * 農薬関連データの管理を開始
         * @param {*} state 
         */
        startManagementAgrichemical: function (state) {

            const docTemplate = db.collection("system").doc("template")

            state.sicks = null
            docTemplate.collection("sicks").doc("data").get().then(function(doc){
                state.sicks = doc.data()
                for (var key in state.sicks.list) {
                    state.sicksArray.push(state.sicks.list[key])
                }
            }).catch (function(error) {
                state.callbacks.logger("index/startManagementAgrichemical(病気取得)", "exception("+error+")")
            })

            state.vermins = null
            docTemplate.collection("vermins").doc("data").get().then(function(doc){
                state.vermins = doc.data()
                for (var key in state.vermins.list) {
                    state.verminsArray.push(state.vermins.list[key])
                }
            }).catch (function(error) {
                state.callbacks.logger("index/startManagementAgrichemical(害虫取得)", "exception("+error+")")
            })

            state.agrichemicals = []
            docTemplate.collection("agrichemicals").get().then(function(snapShot){
                snapShot.forEach(function(doc){
                    const agrichemical = {
                        body: doc.data(),
                        items: {}
                    }
                    state.agrichemicals.push(agrichemical)
                    docTemplate.collection("agrichemicals").doc(agrichemical.body.target+"").collection("items").get().then(function(refItems){
                        refItems.forEach(function(item){
                            const itemData = item.data()
                            agrichemical.items[itemData.agrichemicalNo] = itemData
                        })
                    }).catch (function(error) {
                        state.callbacks.logger("index/startManagementAgrichemical(農薬項目取得)", "exception("+error+")")
                    })
                })
            }).catch (function(error) {
                state.callbacks.logger("index/startManagementAgrichemical(農薬取得)", "exception("+error+")")
            })
        },
        // =================================================================================================================
        /**
         * グループ及び所属グループの管理を開始
         * @param {*} state 
         */
        startManagementGroups: async function (state) {

            const self = this
            const userUID = this.getters["loggedInUserUID"]

            // グループを取得
            state.groups = []

            const refGroups = db.collection("users").doc(userUID).collection("groups")
            await refGroups.orderBy("groupNo", "asc").get()
            .then(function(snapShot){
                snapShot.forEach(function(doc){
                    const group = doc.data()
                    self.commit("managementItems/addGroup", group)
                })
            }).catch (function(error) {
                state.callbacks.logger("index/startManagementGroups(グループ取得)", "exception("+error+")")
            })

            // 所属グループを取得
            state.belongGroups = []

            await db.collection("users").doc(userUID)
            .collection("belong_groups").orderBy("registeredDateTime", "asc").get()
            .then(function(snapShot){
                snapShot.forEach(function(doc){
                    const belongGroup = doc.data()
                    self.commit("managementItems/addBelongGroup", belongGroup)
                })
            }).catch (function(error) {
                state.callbacks.logger("index/startManagementGroups(所属グループ取得)", "exception("+error+")")
            })
        },
        // =================================================================================================================
        /**
         * グループを配列に追加
         * (同時にグループに所属する全ユーザーも取得)
         * @param {*} group (※グループテーブルのレコード)
         */
        addGroup: async function (state, group) {

            const groupData = {
                body: group,
                users: []
            }
            state.groups.push(groupData)

            /** グループのユーザーを取得 */
            const self = this
            const userUID = this.getters["loggedInUserUID"]

            const docGroup = db.collection("users").doc(userUID).collection("groups").doc(group.groupNo+"")
            await docGroup.collection("users").orderBy("registeredDateTime", "asc").get().then(function(snapShot){
                snapShot.forEach(function(doc){
                    const user = doc.data()
                    self.commit("managementItems/addGroupUser", {group: groupData, user: user})
                })
            }).catch (function(error) {
                state.callbacks.logger("index/addGroup(グループユーザー取得)", "exception("+error+")")
            })

            /** グループユーザーを監視 */
            docGroup.collection("users").onSnapshot(
                function(snapShot){
                    snapShot.docChanges().forEach(function(change){
                        const changedUser = change.doc.data()
                        // console.log("group users changed", change.type, changedUser)
                        const targetGroup = state.groups.find((v)=>v.body.groupNo == changedUser.groupNo)
                        if (targetGroup != null) {
                            const targetUser = targetGroup.users.find((v)=>v.body.userUID == changedUser.userUID)
                            switch (change.type) {
                                case "added":
                                    // 追加は無視
                                    break;
                                case "modified":
                                    // 変更時は、状態を反映させる(※別ユーザーからの更新が発生するので)
                                    if (targetUser.body.state != changedUser.state) {
                                        targetUser.body.state = changedUser.state
                                        targetUser.body.updatedDateTime = changedUser.updatedDateTime
                                    }
                                    break;
                                case "removed":
                                    // 削除は無視
                                    break;
                            }
                        }
                    }
                )
            },
            function (error) {
                state.callbacks.logger("index/addGroup", "グループユーザー監視異常("+error+")")
                console.log("index.js", "addGroup", error)
            })

            // console.log(groupData)
        },
        // =================================================================================================================
        /**
         * 所属グループを配列に追加
         * (同時にグループに所属する全ユーザーも取得)
         * @param {*} state 
         * @param {*} belongGroup (※所属グループテーブルのレコード)
         */
        addBelongGroup: async function (state, belongGroup) {

            const belongGroupData = {
                body: belongGroup,
                group: null,
                ownerInfo: {
                    userName: "",
                    avaterURL: ""
                },
                users: []
            }

            // console.log("belongGroupData", belongGroupData)

            state.callbacks.userSetter(belongGroup.ownerUserUID, belongGroupData.ownerInfo)

            state.belongGroups.push(belongGroupData)

            /** 所属グループのグループデータ取得 */
            const docGroup = db.collection("users").doc(belongGroup.ownerUserUID).collection("groups").doc(belongGroup.groupNo+"")

            docGroup.get().then(function(doc){
                belongGroupData.group = doc.data()
            }).catch (function(error) {
                state.callbacks.logger("index/addBelongGroup", "所属グループ取得異常("+error+")")
            })

            /** 所属グループのユーザーを取得 */
            const self = this

            await docGroup.collection("users").orderBy("registeredDateTime", "asc").get().then(function(snapShot){
                snapShot.forEach(function(doc){
                    const user = doc.data()
                    self.commit("managementItems/addGroupUser", {group: belongGroupData, user: user})
                })
            }).catch (function(error) {
                state.callbacks.logger("index/addBelongGroup", "所属グループのユーザー取得異常("+error+")")
            })
        },
        // =================================================================================================================
        /**
         * 指定されたグループor所属グループにユーザーを追加
         * @param {*} state 
         * @param {*} params {group:追加先グループor所属グループ, user:グループユーザー}
         */
        addGroupUser: function (state, params) {
            // console.log(params)
            const userInfo = {
                userName: "",
                avaterURL: ""
            }
            const userData = {
                body: params.user,
                userInfo: userInfo
            }
            params.group.users.push(userData)
            state.callbacks.userSetter(params.user.userUID, userInfo)
        },
        // =================================================================================================================
        /**
         * 送受信した通知の管理を開始
         * @param {*} state 
         */
        startManagementNotifications: async function (state) {

            const self = this
            const userUID = this.getters["loggedInUserUID"]

            // 受信通知を取得
            state.notifications.receiveList.list = []

            await db.collection("users").doc(userUID)
            .collection("notifications").orderBy("dateTime", "desc").limit(state.notifications.maxReadNum).get()
            .then(function(snapShot){
                if (snapShot.size < state.notifications.maxReadNum) {
                    state.notifications.receiveList.allReaded = true
                }
                snapShot.forEach(function(doc){
                    self.commit("managementItems/_addReceivedNotification", {notification: doc.data(), setToFirst: false})
                })
            }).catch (function(error) {
                state.callbacks.logger("index/startManagementNotifications", "受信通知取得異常("+error+")")
            })

            // 受信通知の監視
            db.collection("users").doc(userUID)
            .collection("notifications").orderBy("dateTime", "desc").onSnapshot(function(snapShot){
                snapShot.docChanges().forEach(function(change){
                    const changedNotification = change.doc.data()
                    // console.log("notifications changed", change.type, changedNotification)
                    switch (change.type) {
                        case "added":
                            // 追加時は、既に取得しているデータの受信日時以降であれば取得する
                            if (state.notifications.receiveList.list.length == 0 || state.notifications.receiveList.list[0].body.dateTime < changedNotification.dateTime) {
                                self.commit("managementItems/_addReceivedNotification", {notification: changedNotification, setToFirst: true})
                            }
                            break;
                        case "modified":
                            // 変更は無視
                            break;
                        case "removed":
                            // 削除時
                            const index = state.notifications.receiveList.list.findIndex((v)=>v.body.notificationID == changedNotification.notificationID)
                            if (index >= 0) {
                                state.notifications.receiveList.list.splice(index, 1)
                            }
                            break;
                    }
                })
            },
            function (error) {
                state.callbacks.logger("index/startManagementNotifications", "受信通知監視異常("+error+")")
                console.log("index.js", "startManagementNotifications", "受信監視", error)
            })

            // 送信通知
            state.notifications.sendList.list = []

            await db.collection("users").doc(userUID)
            .collection("sent_notifications").orderBy("notification.dateTime", "desc").limit(state.notifications.maxReadNum).get()
            .then(function(snapShot){
                if (snapShot.size < state.notifications.maxReadNum) {
                    state.notifications.sendList.allReaded = true
                }
                snapShot.forEach(function(doc){
                    self.commit("managementItems/_addSentNotification", {notification: doc.data(), setToFirst: false})
                })
            }).catch (function(error) {
                state.callbacks.logger("index/startManagementNotifications", "送信通知取得異常("+error+")")
            })

            // 送信通知の監視
            db.collection("users").doc(userUID)
            .collection("sent_notifications").orderBy("notification.dateTime", "desc").onSnapshot(function(snapShot){ 
                snapShot.docChanges().forEach(function(change){
                    const changedNotification = change.doc.data()
                    // console.log("sent_notifications changed", change.type, changedNotification, state.notifications.sendList)
                    switch (change.type) {
                        case "added":
                            // 追加時は、既に取得しているデータの送信日時以降であれば取得する
                            if (state.notifications.sendList.list.length == 0 || state.notifications.sendList.list[0].body.notification.dateTime < changedNotification.notification.dateTime) {
                                self.commit("managementItems/_addSentNotification", {notification: changedNotification, setToFirst: true})
                            }
                            break;
                        case "modified":
                            // 変更は無視
                            break;
                        case "removed":
                            // 削除時
                            const index = state.notifications.sendList.list.findIndex((v)=>v.body.notification.notificationID == changedNotification.notification.notificationID)
                            if (index >= 0) {
                                state.notifications.sendList.list.splice(index, 1)
                            }
                            break;
                    }
                })
            },
            function (error) {
                state.callbacks.logger("index/startManagementNotifications", "送信通知監視異常("+error+")")
                console.log("index.js", "startManagementNotifications", "送信監視", error)
            })
        },
        // =================================================================================================================
        /**
         * 受信通知の配列に続きをセット
         * @param {*} state 
         */
        addNextReceivedNotifications: function (state) {

            const self = this
            const userUID = this.getters["loggedInUserUID"]

            var ref = db.collection("users").doc(userUID).collection("notifications")
            if (state.notifications.receiveList.list.length > 0) {
                ref = ref.where("dateTime", "<", state.notifications.receiveList.list[state.notifications.receiveList.list.length-1].body.dateTime)
            }
            ref.orderBy("dateTime", "desc").limit(state.notifications.maxReadNum).get()
            .then(function(snapShot){
                if (snapShot.size < state.notifications.maxReadNum) {
                    state.notifications.receiveList.allReaded = true
                }
                snapShot.forEach(function(doc){
                    self.commit("managementItems/_addReceivedNotification", {notification: doc.data(), setToFirst: false})
                })
            }).catch (function(error) {
                state.callbacks.logger("index/addNextReceivedNotifications", "受信通知取得異常("+error+")")
            })

        },
        // =================================================================================================================
        /**
         * 送信通知の配列に続きをセット
         * @param {*} state 
         */
        addNextSentNotifications: function (state) {

            const self = this
            const userUID = this.getters["loggedInUserUID"]

            var ref = db.collection("users").doc(userUID).collection("sent_notifications")
            if (state.notifications.sendList.list.length > 0) {
                ref = ref.where("notification.dateTime", "<", state.notifications.sendList.list[state.notifications.sendList.list.length-1].body.notification.dateTime)
            }
            ref.orderBy("notification.dateTime", "desc").limit(state.notifications.maxReadNum).get()
            .then(function(snapShot){
                if (snapShot.size < state.notifications.maxReadNum) {
                    state.notifications.sendList.allReaded = true
                }
                snapShot.forEach(function(doc){
                    self.commit("managementItems/_addSentNotification", {notification: doc.data(), setToFirst: false})
                })
            }).catch (function(error) {
                state.callbacks.logger("index/addNextSentNotifications", "送信通知取得異常("+error+")")
            })
        },
        // =================================================================================================================
        /**
         * 受信した通知を配列に格納
         * @param {*} state 
         * @param {*} params 
         * params: {
         *  notification: 通知, 
         *  setToFirst: 配列の先頭に追加する時は、true(これは、DBに通知が登録された時)
         * }
         */
        _addReceivedNotification: function (state, params) {
            try {
                const item = {
                    body: params.notification,
                    sender: {
                        userUID: params.notification.sender != null ? params.notification.sender.userUID : "",
                        userName: "",
                        avaterURL: ""
                    }
                }
                if (params.setToFirst) {
                    state.notifications.receiveList.list.splice(0, 0, item)
                } else {
                    state.notifications.receiveList.list.push(item)
                }
                if (item.sender.userUID != "") {
                    state.callbacks.userSetter(item.sender.userUID, item.sender)
                }
            } catch (error) {
                console.log(error, params)
                state.callbacks.logger("index/_addReceivedNotification", "例外("+error+")")
            }
        },
        // =================================================================================================================
        /**
         * 送信した通知を配列に格納
         * @param {*}} state 
         * @param {*} params {notification: 通知, setToFirst: 配列の先頭に追加する時は、true(これは、DBに通知が登録された時), userSetter: mi_userData()への参照}
         */
        _addSentNotification: function (state, params) {
            const item = {
                body: params.notification,
                receivers: []
            }
            if (params.setToFirst) {
                state.notifications.sendList.list.splice(0, 0, item)
            } else {
                state.notifications.sendList.list.push(item)
            }
            switch (params.notification.type) {
                case "reply":
                case "user":
                    const receiver = {
                        userUID: params.notification.to.userUID,
                        userName: "",
                        avaterURL: ""
                    }
                    item.receivers.push(receiver)
                    state.callbacks.userSetter(receiver.userUID, receiver)                    
                    break;
                case "group_member":
                case "belong_group_member":
                    params.notification.to.users.forEach(function(userUID) {
                        const receiver = {
                            userUID: userUID,
                            userName: "",
                            avaterURL: ""
                        }
                        item.receivers.push(receiver)
                        state.callbacks.userSetter(receiver.userUID, receiver)
                    })
                    break;
                default:
                    params.notification.to.groups.forEach(function(group) {
                        const receiverGroup = {
                            ownerUserUID: group.userUID,
                            groupNo: group.groupNo,
                            groupName: "",
                            users: []
                        }
                        db.collection("users").doc(group.userUID).collection("groups").doc(group.groupNo+"").get().then(function(doc){
                            receiverGroup.groupName = doc.data().groupName
                        })
                        item.receivers.push(receiverGroup)
                        group.users.forEach(function(userUID) {
                            const user = {
                                userUID: userUID,
                                userName: "",
                                avaterURL: ""
                            }
                            receiverGroup.users.push(user)
                            state.callbacks.userSetter(user.userUID, user)
                        })
                    })
                    break;
            }
        }
    }
}

const fieldWork = {
    namespaces: true,
//     state: {
//         fieldWorkMode: 1,               // 作業モード(1:圃場作業,2:予定登録)
//         registeredFields: [],           // 登録されている全圃場
//         registeredBlocks: [],           // 選択された圃場(targetField)に登録されている全区画
//         targetDate: null,               // 選択された作業日(yyyy-MM-dd)
//         targetField: null,              // 選択された圃場
//         targetBlock: null,              // 選択された区画
//         targetSeedBeds: [],             // 選択された全苗床,
//     },
//     getters: {
//         // ===========================================
//         // 作業モード
//         fieldWorkMode: function (state) {
//             return state.fieldWorkMode
//         },
//         // ===========================================
//         // 圃場の栽培地の全タイプが格納された配列
//         fieldPlaceTypes: function (state) {
//             return [
//                 {name:'露場', value:1},
//                 {name:'ハウス', value:2},
//             ]
//         },
//         // ===========================================
//         // 収穫物のサイズが格納された配列
//         varietySizes: function (state) {
//             return [
//                 {value:0, name:"未設定"},
//                 {value:1, name:"小"},
//                 {value:2, name:"中"},
//                 {value:3, name:"大"},
//             ]
//         },
//         // ===========================================
//         // 収穫物の外観が格納された配列
//         varietyAppearances: function (state) {
//             return [
//                 {value:0, text:'未設定'},
//                 {value:1, text:'◎'},
//                 {value:2, text:'○'},
//                 {value:3, text:'△'},
//                 {value:4, text:'×'},
//             ]
//         },
//         // ===========================================
//         // 観察の状態が格納された配列
//         observationStates: function (state) {
//             return [
//                 {value:0, text:'未設定'},
//                 {value:90, text:'発病'},
//             ]
//         },
//         // ===========================================
//         // 登録されている全圃場が格納された配列
//         registeredFields: function (state) {
//             return state.registeredFields
//         },
//         // ===========================================
//         // 選択されている圃場で登録されている全区画が格納された配列
//         registeredBlocks: function (state) {
//             return state.registeredBlocks
//         },
//         // // ===========================================
//         // // 選択されている区画で行われた苗床作業が格納された配列
//         // registeredSeedBedWorks: function (state) {
//         //     return state.registeredSeedBedWorks
//         // },
//         // ===========================================
//         // 選択された作業日
//         targetDate: function (state) {
//             return state.targetDate
//         },
//         // ===========================================
//         // 選択された圃場
//         targetField: function (state) {
//             return state.targetField
//         },
//         // ===========================================
//         // 選択された区画
//         targetBlock: function (state) {
//             return state.targetBlock
//         },
//         // ===========================================
//         // 選択された苗床(複数)
//         targetSeedBeds: function (state) {
//             return state.targetSeedBeds
//         },
//     },
    mutations: {
//         // ===========================================
//         // 作業モード
//         fieldWorkMode: function (state, mode) {
//             state.fieldWorkMode = mode
//         },
//         // ===========================================
//         // 全圃場をDBに登録されている内容で更新する
//         // params: {
//         //     success:成功時(全読取終了後)のコールバック,
//         //     failed:失敗時のコールバック
//         // }
//         refreshRegisteredFields: function (state, params) {
//             console.log("store/index.js", "refreshRegisteredFields", "start", params)
//             try {
//                 if (params == null) {
//                     params = {}
//                 }
//                 const userUID = this.getters["userUID"]
//                 // console.log("store/index.js", "refreshRegisteredFields", "target userUID", userUID)
    
//                 state.registeredFields = []
//                 var fields = db.collection("users").doc(userUID).collection("fields")
//                 fields.get().then(function(snapShot){
//                     if (snapShot.size == 0 && params.success != null) {
//                         params.success()
//                     } else {
//                         snapShot.forEach(function(doc){
//                             var field = doc.data()
//                             state.registeredFields.push(field)
//                             // console.log("field", field)
//                             if (state.registeredFields.length == snapShot.size && params.success != null) {
//                                 params.success()
//                             }
//                         })
//                     }
//                 }).catch (function (error){
//                     console.log(error)
//                     if (params.failed != null) {
//                         params.failed(error)
//                     }
//                 })    
//             } catch (error) {
//                 console.log(error)
//             }
//         },
//         // ===========================================
//         // 全区画を指定された圃場IDでDBに登録されている内容で更新する
//         // params: {
//         //     field: 圃場,
//         //     success:成功時(全読取終了後)のコールバック,
//         //     failed:失敗時のコールバック
//         // }
//         refreshRegisteredBlocks: function (state, params) {
//             const userUID = this.getters["userUID"]
//             state.registeredBlocks = []
//             db.collection("users").doc(userUID).collection("fields").doc(""+params.field.fieldID).collection("blocks").get().then(function(snapShot){
//                 snapShot.forEach(function(doc){
//                     var block = doc.data()
//                     state.registeredBlocks.push(block)
//                     if (state.registeredBlocks.length == snapShot.size && params.success != null) {
//                         params.success()
//                     }
//                 })
//             }).catch (function (error){
//                 if (params.failed != null) {
//                     params.failed(error)
//                 }
//             })
//         },
//         // ===========================================
//         // 引数で指定された圃場を更新する
//         updateField: function (state, params) {

//             var fillZero = function ( number ) {
//                 return ("0" + number).slice(-2);
//             }                      

//             const d = new Date()

//             var currentDateTime = d.getFullYear() + "/" + fillZero(d.getMonth()+1) + "/" + fillZero(d.getDate()) + " " +
//                                   fillZero(d.getHours()) + ":" + fillZero(d.getMinutes()) + ":" + fillZero(d.getSeconds())

//             var isNewData = false

//             // 圃場ID=0 の時は、新規追加
//             // それ以外は、更新
//             if (params.field.fieldID == 0) {
//                 if (state.registeredFields.length == 0) {
//                     params.field.fieldID = 1
//                 } else {
//                     var maxFieldID = Math.max(...state.registeredFields.map(m => m.fieldID))
//                     params.field.fieldID = maxFieldID + 1
//                 }
//                 params.field.registeredDateTime = currentDateTime
//                 isNewData = true
//             } else {
//                 params.field.updatedDateTime = currentDateTime
//             }
            
//             const userUID = this.getters["userUID"]

//             db.collection("users").doc(userUID).collection("fields").doc(""+params.field.fieldID).set(params.field).then(function(){
//                 if (isNewData == true) {
//                     state.registeredFields.push(params.field)
//                 } else {
//                     const index = state.registeredFields.findIndex((v) => v.fieldID === params.field.fieldID)
//                     state.registeredFields.splice(index, 1)
//                     state.registeredFields.splice(index, 0, params.field)
//                 }
//                 if (params.success != null) params.success()
//             }).catch(function(error){
//                 console.log("store/index.js", "updateField", "failed", error)
//                 if (params.failed != null) params.failed()
//             })
//         },
//         // ===========================================
//         // 引数で指定された区画を更新する
//         // params: {
//         //     field:
//         //     block:
//         //     success:
//         //     failed:
//         // }
//         updateBlock: function (state, params) {

//             if (params.field == undefined) params.field = state.targetField
//             if (params.block == undefined) params.block = state.targetBlock

//             var fillZero = function ( number ) {
//                 return ("0" + number).slice(-2);
//             }                      

//             const d = new Date()

//             var currentDateTime = d.getFullYear() + "/" + fillZero(d.getMonth()+1) + "/" + fillZero(d.getDate()) + " " +
//                                   fillZero(d.getHours()) + ":" + fillZero(d.getMinutes()) + ":" + fillZero(d.getSeconds())

//             var isNewData = false

//             // 区画ID=0 の時は、新規追加
//             // それ以外は、更新
//             if (params.block.blockID == 0) {
//                 if (state.registeredBlocks.length == 0) {
//                     params.block.blockID = 1
//                 } else {
//                     var maxBlockID = Math.max(...state.registeredBlocks.map(m => m.blockID))
//                     params.block.blockID = maxBlockID + 1
//                 }
//                 params.block.registeredDateTime = currentDateTime
//                 isNewData = true
//             } else {
//                 params.block.updatedDateTime = currentDateTime
//             }
            
//             const userUID = this.getters["userUID"]

//             db.collection("users").doc(userUID).collection("fields").doc(""+params.block.fieldID).collection("blocks").doc(""+params.block.blockID).set(params.block).then(function(){
//                 if (isNewData == true) {
//                     state.registeredBlocks.push(params.block)
//                     console.log("index.js", "updateBlock", "newData", state.registeredBlocks)
//                 } else {
//                     const index = state.registeredBlocks.findIndex((v) => v.blockID === params.block.blockID)
//                     state.registeredBlocks.splice(index, 1)
//                     state.registeredBlocks.splice(index, 0, params.block)
//                     console.log("index.js", "updateBlock", "updateData", state.registeredBlocks)
//                 }
//                 if (params.success != null) params.success()
//             }).catch(function(error){
//                 console.log("store/index.js", "updateBlock", "failed", error)
//                 if (params.failed != null) params.failed()
//             })
//         },
//         // ===========================================
//         // 定植開始処理
//         // params: {
//         //     seedBeds: 定植を開始する全苗床
//         //     success:
//         //     failed:
//         // }
//         startPlant: function (state, params) {
//             console.log("store/index.js", "startPlant", "start", params)
//             const userUID = this.getters["userUID"]
//             var batch = db.batch()
//             var count = 0
//             params.seedBeds.forEach(function(seedBed){
//                 console.log(seedBed)
//                 // 苗床
//                 var seedBeds = db.collection("users").doc(userUID).collection("fields").doc(""+seedBed.seedBed.fieldID).
//                     collection("blocks") .doc(""+seedBed.seedBed.blockID).collection("seed_beds")
//                 var docSeedBed = seedBeds.doc(""+seedBed.seedBed.seedBedNo)
//                 batch.set(docSeedBed, seedBed.seedBed)
//                 // 苗木
//                 var plants = docSeedBed.collection("plants")
//                 var docPlant = plants.doc(""+seedBed.currentPlant.plant.plantNo)
//                 batch.set(docPlant, seedBed.currentPlant.plant)

//                 count++
//                 if (count == params.seedBeds.length) {
//                     batch.commit().then(function() {
//                         if (params.success != null) params.success()
//                     }).catch(function(error){
//                         if (params.failed != null) params.failed(error)
//                     })
//                 }
//             })
//         },
//         // // ===========================================
//         // // 苗床作業を更新する
//         // // params: {
//         // //     workOfDay: 日別苗床作業
//         // //     work: 追加する作業
//         // //     success:
//         // //     failed:
//         // // }
//         // updateSeedBedWork: function (state, params) {
//         //     console.log("store/index.js", "updateSeedBedWork", "start", params)

//         //     if (params.work.workNo == 0) {
//         //         var workNo = 1
//         //         if (params.workOfDay.works.length > 0) {
//         //             workNo = Math.max(...params.workOfDay.works.map(m => m.workNo)) + 1
//         //         }
//         //         params.work.workNo = workNo
//         //         params.workOfDay.works.push(params.work)
//         //     } else {
//         //         const index = params.workOfDay.works.findIndex((v) => v.workNo === params.work.workNo)
//         //         params.workOfDay.works.splice(index, 1)
//         //         params.workOfDay.works.splice(index, 0, params.work)
//         // }

//         //     const userUID = this.getters["userUID"]
//         //     var block = db.collection("users").doc(userUID).collection("fields").doc(""+params.workOfDay.fieldID).collection("blocks").doc(""+params.workOfDay.blockID)
//         //     var seedBedWorks = block.collection("seed_beds").doc(""+params.workOfDay.seedBedNo).collection("works")
//         //     seedBedWorks.doc(params.workOfDay.workDate).set(params.workOfDay).then(function(){
//         //         console.log("store/index.js", "updateSeedBedWork", "success", params)
//         //         if (params.success != null) {
//         //             params.success()
//         //         }
//         //     }).catch(function(error){
//         //         console.log("store/index.js", "updateSeedBedWork", "failed", error)
//         //         if (params.failed != null) params.failed()
//         //     })
//         // },
//         // ===========================================
//         // 収穫データを更新する
//         // params: {
//         //     harvest:
//         //     success:
//         //     failed:
//         // }
//         updateHarvest: function (state, params) {
//             console.log("store/index.js", "updateHarvest", "start", params)
//             const userUID = this.getters["userUID"]
//             var block = db.collection("users").doc(userUID).collection("fields").doc(""+params.harvest.fieldID).collection("blocks").doc(""+params.harvest.blockID)
//             var seedBed = block.collection("seed_beds").doc(""+params.harvest.seedBedNo)
//             var plant = seedBed.collection("plants").doc(params.harvest.plantNo)
//             var harvests = plant.collection("harvests")
//             harvests.doc(""+params.harvest.harvestNo).set(params.harvest).then(function(){
//                 if (params.success != null) {
//                     params.success()
//                 }
//             }).catch (function (error){
//                 if (params.failed != null) {
//                     params.failed(error)
//                 }
//             })
//         },
//         // ===========================================
//         // 観察データを更新する
//         // params: {
//         //     plant: 苗木 
//         //     observate: 観察データ,
//         //     updatePlant: 苗木情報も更新する時は、True(※苗木情報が持つ観察データを更新した時にTrueに設定)
//         //     success:
//         //     failed:
//         // }
//         updateObservate: function (state, params) {
//             console.log("store/index.js", "updateObservation", "start", params)

//             const userUID = this.getters["userUID"]
//             var block = db.collection("users").doc(userUID).collection("fields").doc(""+params.observate.fieldID).collection("blocks").doc(""+params.observate.blockID)
//             var seedBed = block.collection("seed_beds").doc(""+params.observate.seedBedNo)
//             var plant = seedBed.collection("plants").doc(params.observate.plantNo)
//             var observates = plant.collection("observates")
//             var batch = db.batch()

//             if (params.updatePlant) {
//                 batch.set(plant, params.plant)
//             }

//             batch.set(observates.doc(""+params.observate.observateNo), params.observate)
//             batch.commit().then(function(){
//                 console.log("store/index.js", "updateObservate", "success", params)
//                 if (params.success != null) {
//                     params.success()
//                 }
//             }).catch(function(error){
//                 console.log("store/index.js", "updateObservate", "failed", error)
//                 if (params.failed != null) params.failed()
//             })
//         },
//         // ===========================================
//         // 作業履歴を登録
//         // params: {
//         //     workDate: 作業日 
//         //     workDateTime: 作業日時 
//         //     workType:1(定植),:2(収穫),:3(観察)
//         //     workKey:(workTypeによって変わる - 仕様書参照)
//         //     workNum: 作業数(例えば、複数の苗床に対して一度に定植した時は苗床の数を設定する。 未指定時は 1) 
//         //     success:
//         //     failed:
//         // }
//         registWorkHistory: function (state, params) {
//             console.log("store/index.js", "registWorkHistory", "start", params)
//             if (params.workNum == undefined) params.workNum = 1

//             // ===============
//             // 作業日付と年月と日
//             const dateValues = params.workDate.split("-")
//             const workMonth = dateValues[0]+"-"+dateValues[1]
//             const workDay = dateValues[2]
            
//             // ===============
//             // 日別作業情報取得
//             const userUID = this.getters["userUID"]
//             var docDailyHistory = db.collection("users").doc(userUID).
//                                collection("monthly_work_histories").doc(workMonth).
//                                collection("daily_work_histories").doc(workDay)
//             docDailyHistory.get().then(function(doc){
//                 var dailyInfo = null
//                 if (doc.exists) {
//                     dailyInfo = doc.data()
//                 } else {
//                     dailyInfo = {
//                         version: "1.0.0",
//                         workDate: params.workDate,
//                         countsByWork: []
//                     }
//                 }
//                 console.log("dailyInfo", dailyInfo)

//                 // ===============
//                 // 日別作業情報内の作業回数更新
//                 const workIndex = dailyInfo.countsByWork.findIndex((v) => v.workType === params.workType)
//                 if (workIndex < 0) {
//                     dailyInfo.countsByWork.push({
//                         workType: params.workType,
//                         count: params.workNum
//                     })
//                 } else {
//                     dailyInfo.countsByWork[workIndex].count += params.workNum
//                 }

//                 // ===============
//                 // 日別作業情報更新
//                 var batch = db.batch()
//                 batch.set(docDailyHistory, dailyInfo)

//                 // ===============
//                 // 作業履歴登録
//                 var docHistory = docDailyHistory.collection("work_histories").doc(""+params.workType).collection("histories").doc(params.workDateTime)
//                 const history = {
//                     version: "1.0.0",
//                     workDate: params.workDate,
//                     workDateTime: params.workDateTime,
//                     workType: params.workType,
//                     workKey: params.workKey
//                 }
//                 batch.set(docHistory, history)

//                 // ===============
//                 // コミット
//                 batch.commit().then(function(){
//                     if (params.success != null) params.success()
//                 }).catch(function(error){
//                     if (params.failed != null) params.failed(error)
//                 })
//             }).catch(function(error){
//                 if (params.failed != null) params.failed(error)
//             })
//         },
//         // ===========================================
//         // 作業日を更新する(yyyy-MM-dd)
//         targetDate: function (state, value) {
//             console.log("store/index.js", "targetDate", value)
//             state.targetDate = value
//         },
//         // ===========================================
//         // 作業対象の圃場を更新する
//         targetField: function (state, value) {
//             console.log("store/index.js", "targetField", value)
//             state.targetField = value
//         },
//         // ===========================================
//         // 作業対象の区画を更新する
//         // params: {
//         //     block:
//         //     isSetCurrentSeedBeds: True もしくは未指定で、現在の全苗床を取得する(※Falseは通知、履歴などのデータから処理を行う際 ... 過去データなどは現在のデータを取得しないようにする為)
//         //     success:
//         //     failed:
//         // }        
//         targetBlock: function (state, params) {
//             console.log("store/index.js", "targetBlock", params)

//             state.targetBlock = {
//                 block: params.block,
//                 seedBeds: [],                
//             }
            
//             if (params.isSetCurrentSeedBeds != null && params.isSetCurrentSeedBeds == false) {
//                 return
//             }

//             // DBに登録されている全ての苗床を取得
//             const userUID = this.getters["userUID"]

//             var seedBeds = db.collection("users").doc(userUID).collection("fields").doc(""+params.block.fieldID).
//                            collection("blocks").doc("" + params.block.blockID).collection("seed_beds")

//             seedBeds.orderBy("seedBedNo").get().then(function(snapShot){

//                 if (snapShot.size == 0) {
//                     if (params.success != null) params.success()
//                     return
//                 }

//                 var registeredSeedBedNum = snapShot.size
//                 var count = 0

//                 snapShot.forEach(function(doc){
//                     var seedBed = {
//                         seedBed: doc.data(),
//                         currentPlant: {
//                             plant: null,
//                             harvests: [],
//                             observates: []
//                         }
//                     }

//                     state.targetBlock.seedBeds.push(seedBed)
//                     count++

//                     const isLast = (count == registeredSeedBedNum)

//                     if (seedBed.seedBed.currentPlant != null) {
//                         var plants = seedBeds.doc(""+seedBed.seedBed.seedBedNo).collection("plants")

//                         plants.doc(seedBed.seedBed.currentPlant.plantNo).get().then(function(doc){
//                             if (doc.exists) {
//                                 seedBed.currentPlant.plant = doc.data()
//                             }
//                             if (isLast) {
//                                 if (params.success != null) params.success()
//                             }
//                         }).catch(function(error) {
//                             if (params.failed != null) params.failed(error)
//                         })                    
//                     } else if (isLast) {
//                         if (params.success != null) params.success()
//                     }
//                 })
//             }).catch(function(error) {
//                 if (params.failed != null) params.failed(error)
//             })
//         },
//         // // ===========================================
//         // // 作業対象の区画に定植中の苗床を追加する
//         // // ※DBは更新されない
//         // addPlantingSeedBeds: function (state, seedBeds) {
//         //     console.log("store/index.js", "addPlantingSeedBeds", "start", seedBeds)
//         //     for (var index=0; index<seedBeds.length; index++) {
//         //         state.targetBlock.plantingInformations.push(seedBeds[index].plantingInformation)
//         //     }
//         //     console.log("store/index.js", "addPlantingSeedBeds", "end", state.targetBlock.plantingSeedBeds)
//         // },
//         // ===========================================
//         // 作業対象の苗床が格納されている配列をクリアする
//         clearTargetSeedBed: function (state) {
//             state.targetSeedBeds = []
//         },
//         // ===========================================
//         // 作業対象の苗床を追加する
//         // このタイミングで、対象の苗床の収穫データと観察データを最新状態に更新
//         // params: {
//         //     seedBed:
//         //     stateListener: 状態を取得するリスナー
//         //                    引数: state ... 1:全観察データ取得終了,2:全収穫データ取得終了,0:データ無し(定植されていない苗床)
//         // }
//         addTargetSeedBed: function (state, params) {

//             console.log("store/index.js", "addTargetSeedBed", "start", params)
            
//             state.targetSeedBeds.push(params.seedBed)

//             const userUID = this.getters["userUID"]

//             // 定植されていない時は、以降の処理は行わない
//             if (params.seedBed.seedBed.currentPlant == null) {
//                 console.log("定植されていない苗床")
//                 if (params.stateListener != null) {params.stateListener(0)}
//                 return
//             }

//             // 苗木の観察・収穫データ取得
//             var block = db.collection("users").doc(userUID).collection("fields").doc(""+params.seedBed.seedBed.fieldID).collection("blocks").doc(""+params.seedBed.seedBed.blockID)
//             var plant = block.collection("seed_beds").doc(""+params.seedBed.seedBed.seedBedNo).collection("plants").doc(params.seedBed.seedBed.currentPlant.plantNo)

//             // 苗木の全観察データを取得
//             if (params.seedBed.currentPlant.observates.length == 0) {
//                 plant.collection("observates").get().then(function(snapShot){
//                     if (snapShot.size > 0) {
//                         snapShot.forEach(function(doc) {
//                             var observateData = doc.data()
//                             params.seedBed.currentPlant.observates.push(observateData)
//                             if (params.stateListener != null && params.seedBed.currentPlant.observates.length == snapShot.size) {
//                                 params.stateListener(1)
//                             }
//                         })
//                     } else {
//                         if (params.stateListener != null) {
//                             params.stateListener(1)
//                         }
//                     }
//                 })
//             } else {
//                 if (params.stateListener != null) {
//                     params.stateListener(1)
//                 }
//             }

//             // 苗木の全収穫データを取得
//             if (params.seedBed.currentPlant.harvests.length == 0) {
//                 plant.collection("harvests").get().then(function(snapShot){
//                     if (snapShot.size > 0) {
//                         snapShot.forEach(function(doc) {
//                             var harvestData = doc.data()
//                             params.seedBed.currentPlant.harvests.push(harvestData)
//                             if (params.stateListener != null && params.seedBed.currentPlant.harvests.length == snapShot.size) {
//                                 params.stateListener(2)
//                             }
//                         })
//                     } else {
//                         if (params.stateListener != null) {
//                             params.stateListener(2)
//                         }
//                     }
//                 })
//             } else {
//                 if (params.stateListener != null) {
//                     params.stateListener(2)
//                 }
//             }
//         },
//         // ===========================================
//         // 作業対象の苗床を削除する
//         removeTargetSeedBed: function (state, value) {
//             const index = state.targetSeedBeds.findIndex((v) => v.seedBed.seedBedNo === value.seedBed.seedBedNo)
//             if (index >= 0) {
//                 state.targetSeedBeds.splice(index, 1)
//             }
//         },
        // ===========================================
        // 通知を送信する
        // params: {
        //     batch: バッチ処理の時は、このフィールドにバッチをセット(この時、success,failedは無効)。それ以外は未指定。 
        //     to: {
        //         userUID:UID
        //     },
        //     sender: {
        //         userUID:UID
        //         userData:ユーザーデータ
        //     },
        //     content: {
        //         type:
        //         title:
        //         message:
        //     },
        //     data: {
        //         (type=10 の時)
        //         groupNo:
        //         groupName
        //     },
        //     success:
        //     failed:
        // }
        sendNotification: function (state, params) {
            // console.log("store/index.js", "sendNotification", "start", params)
            try {
                var fillZero = function ( number ) {
                    return ("0" + number).slice(-2);
                }                      
                const d = new Date()
                const currentDateTime = d.getFullYear() + "-" + fillZero(d.getMonth()+1) + "-" + fillZero(d.getDate()) + " " +
                                        fillZero(d.getHours()) + ":" + fillZero(d.getMinutes()) + ":" + fillZero(d.getSeconds())
                const notificationID = currentDateTime.replace(/\-/g, '').replace(/:/g, '').replace(/ /g, '')
    
                // var avaterURL = function(userData) {
                //     if (userData.avaterImage != null) {
                //         return userData.avaterImage.url
                //     } else {
                //         return null
                //     }
                // }
        
                var sender = null
                if (params.sender != null) {
                    sender = {
                        userUID: params.sender.userUID,
                        // userID: params.sender.userData.userID,
                        // name: params.sender.userData.userName,
                        // avaterURL: avaterURL(params.sender.userData)
                    }
                }
                const notification = {
                    version: "1.0.0",
                    notificationID: notificationID,
                    dateTime: currentDateTime,
                    sender: sender,
                    content: {
                        type: params.content.type,
                        title: params.content.title,
                        message: params.content.message
                    },
                    data: params.data,
                    openedDateTime: ""
                }
                
                if (params.batch != undefined) {
                    // console.log("sendNotification", "batch mode")
                    params.batch.set(db.collection("users").doc(params.to.userUID).collection("notifications").doc(""+notificationID), notification)
                    return
                }

                db.collection("users").doc(params.to.userUID).collection("notifications").doc(""+notificationID).set(notification).then(function(){
                    if (params.success != null) {params.success()}
                }).catch (function(error){
                    if (params.failed != null) {params.failed(error)}
                })
            } catch (error) {
                if (params.failed != null) {params.failed(error)}
            }
        },
        // ===========================================
        // 指定された通知を開封済みに更新する
        // params: {
        //     notification:
        //     openedDateTime: 
        //     success:
        //     failed:
        // }
        openedNotification: function (state, params) {
            // console.log("store/index.js", "openedNotification", "start", params)
            try {
                // var fillZero = function ( number ) {
                //     return ("0" + number).slice(-2);
                // }                      
                // const d = new Date()
                // const currentDateTime = d.getFullYear() + "-" + fillZero(d.getMonth()+1) + "-" + fillZero(d.getDate()) + " " +
                //                         fillZero(d.getHours()) + ":" + fillZero(d.getMinutes()) + ":" + fillZero(d.getSeconds())

                const userUID = this.getters["userUID"]
                db.collection("users").doc(userUID).collection("notifications").doc(""+params.notification.notificationID).update(
                    {
                        "openedDateTime":params.openedDateTime
                    }
                ).then(function(){
                    params.notification.openedDateTime = params.openedDateTime
                    if (params.success != null) {params.success()}
                }).catch (function(error){
                    if (params.failed != null) {params.failed(error)}
                })
            } catch (error) {
                if (params.failed != null) {params.failed(error)}
            }
        },
        // ===========================================
        // 指定されたシステム通知を開封済みに更新する
        // params: {
        //     notification:
        //     openedDateTime: 
        //     success:
        //     failed:
        // }
        openedSystemNotification: function (state, params) {
            // console.log("store/index.js", "openedSystemNotification", "start", params)
            try {
                // var fillZero = function ( number ) {
                //     return ("0" + number).slice(-2);
                // }                      
                // const d = new Date()
                // const currentDateTime = d.getFullYear() + "-" + fillZero(d.getMonth()+1) + "-" + fillZero(d.getDate()) + " " +
                //                         fillZero(d.getHours()) + ":" + fillZero(d.getMinutes()) + ":" + fillZero(d.getSeconds())

                const userUID = this.getters["userUID"]
                db.collection("users").doc(userUID).collection("system_notifications").doc(""+params.notification.notificationID).update(
                    {
                        "openedDateTime":params.openedDateTime
                    }
                ).then(function(){
                    params.notification.openedDateTime = params.openedDateTime
                    if (params.success != null) {params.success()}
                }).catch (function(error){
                    if (params.failed != null) {params.failed(error)}
                })
            } catch (error) {
                if (params.failed != null) {params.failed(error)}
            }
        }
    }
}

export const store = new Vuex.Store(
    {
        modules: {
            systemState,
            userData,
            areaInformation,
            managementItems,
            fieldWork
        }
    }
)

